import { createTheme } from '@mui/material/styles';

// Global styles for form inputs
const globalStyles = {
  // Number input spinners
  'input[type=number]': {
    'MozAppearance': 'textfield',
  },
  'input[type=number]::-webkit-outer-spin-button, input[type=number]::-webkit-inner-spin-button': {
    'WebkitAppearance': 'none',
    margin: 0,
  },
  // Date picker
  '.MuiPickersPopper-root': {
    '& .MuiPaper-root': {
      backgroundColor: '#2a2a2a',
      color: '#fff',
    },
    '& .MuiPickersCalendarHeader-label': {
      color: '#fff',
    },
    '& .MuiPickersDay-root': {
      color: '#fff',
      '&.Mui-selected': {
        backgroundColor: '#17ffc4',
        color: '#000',
        '&:hover': {
          backgroundColor: '#15e6b0',
        },
      },
      '&.Mui-disabled': {
        color: '#666',
      },
    },
    '& .MuiPickersDay-today': {
      borderColor: '#17ffc4',
    },
    '& .MuiPickersCalendarHeader-switchViewButton': {
      color: '#17ffc4',
    },
    '& .MuiIconButton-root': {
      color: '#fff',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
    },
  },
};

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#06D001',
    },
    background: {
      default: '#333333',
      paper: '#424242',
    },
    custom: {
      button: '#affc41',
      logout: '#b7094c',
      download: '#1dd3b0',
      background: '#2a2a2a',
      paper: '#333333',
      text: '#ffffff'
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: globalStyles,
    },
    MuiButton: {
      styleOverrides: {
        // Style for the navigation buttons (GST, Logs, etc.)
        containedPrimary: {
          backgroundColor: theme => theme.palette.custom.button,
          '&:hover': {
            backgroundColor: '#8bbd2a',
          },
          color: '#000',
          marginRight: '8px',
          minWidth: '120px',
          fontWeight: 700,
          fontSize: '1rem',
          padding: '10px 20px',
          whiteSpace: 'nowrap',
          '&.MuiButton-contained.MuiButton-containedPrimary': {
            backgroundColor: theme => theme.palette.custom.button,
            color: '#000',
          },
        },
        // Style for the Settlement button (using primary style to match others)
        containedSecondary: {
          backgroundColor: theme => theme.palette.custom.button,
          '&:hover': {
            backgroundColor: '#8bbd2a',
          },
          color: '#000',
          marginRight: '8px',
          minWidth: '120px',
          fontWeight: 700,
          fontSize: '1rem',
          padding: '10px 20px',
          whiteSpace: 'nowrap',
          '&.MuiButton-contained.MuiButton-containedSecondary': {
            backgroundColor: theme => theme.palette.custom.button,
          },
        },
        // Style for the Logout button
        containedError: {
          backgroundColor: theme => theme.palette.custom.logout,
          '&:hover': {
            backgroundColor: '#8c0638',
          },
          color: '#fff',
          minWidth: '120px',
          fontWeight: 700,
          fontSize: '1rem',
          padding: '10px 20px',
          whiteSpace: 'nowrap',
          '&.MuiButton-contained.MuiButton-containedError': {
            backgroundColor: theme => theme.palette.custom.logout,
          },
        },
      },
    },
  },
});

export default theme;
